import { render, staticRenderFns } from "./single-column-item.vue?vue&type=template&id=41e73c98"
var script = {}
import style0 from "./single-column-item.vue?vue&type=style&index=0&id=41e73c98&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports